var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitzerland01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 282.65 282.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .swiss-1 {\n        fill: #fff;\n      }\n\n      .swiss-2 {\n        fill: red;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_\\xD1\\xEB\\xEE\\xE9_1",
    "data-name": "\\xD1\\xEB\\xEE\\xE9_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "swiss-2",
    cx: 141.33,
    cy: 141.33,
    r: 141.33,
    transform: "translate(-58.54 141.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "swiss-1",
    points: "229.25 113.24 167.51 113.24 167.51 51.5 115.15 51.5 115.15 113.24 53.4 113.24 53.4 165.61 115.15 165.61 115.15 227.35 167.51 227.35 167.51 165.61 229.25 165.61 229.25 113.24"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitzerland01);
export default __webpack_public_path__ + "static/media/Switzerland-01.fc5807d87258189401cb645b8ab5ed7c.svg";
export { ForwardRef as ReactComponent };